import { createFeatureSelector } from '@ngrx/store';

export const loylatyProductProgramsState = createFeatureSelector<OLO.State, OLO.State.LoyaltyProductProgramItem>('loyaltyProductPrograms');
